import Common from '../common'
var Js = Common('dashboard')
export default {
	name: 'dashboard',
	mixins: [Js],
	components: {},
	data() {
		return {
			fields: [{
					key: 'id',
					label: 'ID',
					application: [],
					componentName: 'sls-input',
					listType: 'normal',
					width: 50
				},
				{
					key: 'type',
					label: '状态',
					application: ['编辑'],
					formatter: function(val, tests) {
						var testArray = ['未处理', '已处理']
						return testArray[val.type];
					},
					componentName: 'sls-select',
					optionsName: 'typeOptions',
					listType: 'normal',
					limit: 10,
					defaultProps: {
						label: 'text',
						value: 'value',
					},
					placeholder: '请选择状态',
					width: 100,
					header_search: {
						componentName: 'sls-select',
						optionsName: 'typeOptions',
						style: 'width:160px;margin-right:2px;',
						placeholder: '请选择状态',
						changeFunc: function(val, self) {
							if (val) {
								self.searchItem.type = val;
							} else {
								delete self.searchItem.type;
							};
							self.initMainData(true);
						},
					}
				},
				{
					key: 'title',
					label: '姓名',
					application: ['编辑'],
					componentName: 'sls-input',
					listType: 'normal',
				},
				{
					key: 'content',
					label: '备注',
					application: ['编辑'],
					componentName: 'sls-textarea',
					listType: 'normal',
					dialogStyle: 'width:90%'
				},
				{
					key: 'phone',
					label: '电话',
					application: ['编辑'],
					componentName: 'sls-input',
					listType: 'normal',
				},
				{
					key: 'create_time',
					label: '创建时间',
					listType: 'normal',
					placeholder: '请选择创建时间',

					width: 200,
				},
				{
					label: '操作',
					listType: 'deal',
					width: 200
				},
			],
			// 按钮配置
			btn_info: [



				{
					type: 'info',
					icon: 'edit',
					size: 'mini',
					position: 'list',
					text: function(data) {
						return '编辑'
					},
					func: {
						apiName: function(self) {
							return "api_messageUpdate"
						},
						formData: function(self) {
							return self.formData
						},
						postData: function(self) {
							var postData = {
								searchItem: {
									id: self.formData.id,
								},
								data: self.submitData
							};
							if (self.submitData.parentid && self.submitData.parentid == self.formData.id) {
								self.$$notify('父级ID和子级ID重叠', 'fail');
								return false;
							} else {
								return postData;
							};

						},
						callback: function(self) {
							self.initMessageData(true)
						}
					},
				},


				{
					type: 'danger',
					icon: 'delete',
					size: 'mini',
					funcType: 'submit',
					position: 'header',
					text: function(data) {
						return '删除选中'
					},
					func: {

						apiName: function(self) {
							return "api_routineUpdate"
						},

						postData: function(self) {
							var deleteArray = [];
							for (var i = 0; i < self.selectionArray.length; i++) {
								deleteArray.push(self.selectionArray[i].id);
							};
							var postData = {
								searchItem: {
									id: ['in', deleteArray],
								},
								data: {
									status: -1
								}
							};
							return postData;
						}

					},
				},

				{
					type: 'info',
					icon: 'edit',
					size: 'mini',
					position: 'list',
					text: function(data) {
						return '编辑信息'
					},
					func: {
						apiName: function(self) {
							if (JSON.stringify(self.user) == "{}") {
								return "api_userInfoAdd";
							} else {
								return "api_userInfoUpdate";
							};
						},
						formData: function(self) {
							return self.user
						},
						postData: function(self) {
							var postData = {
								searchItem: {
									id: self.formData.id,
								},
								data: self.submitData
							};
							if (self.submitData.parentid && self.submitData.parentid == self.formData.id) {
								self.$$notify('父级ID和子级ID重叠', 'fail');
								return false;
							} else {
								return postData;
							};

						},
						callback: function(self) {
							self.initUserInfoData()
						}
					},
				},


			],


			visitorPaginate: {
				count: 0,
				currentPage: 1,
				pagesize: 10,
				is_page: true,
				page_sizes: [10, 30, 60, 90],
				layout: 'total, sizes, prev, pager, next, jumper',
			},
			searchItem: {
				behavior: 1,
				transport_status: 0
			},
			startSearchItem: {
				behavior: 1,
				transport_status: 0
			},
			optionData: {
				labelOptions: [],
				typeOptions: [{
					text: '未处理',
					value: 0
				}, {
					text: '已处理',
					value: 1
				}],
			},
			otherData: {},
			UserInfo: {
				tableName: 'UserInfo',
				searchItem: {},
				fixSearchItem: {
					status: 1
				},
				key: 'user_no',
				middleKey: 'user_no',
				condition: 'in',
			},

			user: {},
			isSign: false,
			visitorData: [],
			echartsOptions: {},
			loading: false,
			timeArr: []
		}

	},

	mounted() {
		this.init()
	},
	computed: {
		token: function() {
			return this.$store.getters.getToken
		}
	},
	methods: {


		timeChange(e) {
			const self = this;
			if (e.value && e.value != null) {
				self.timeArr = [e.value[0] / 1000, e.value[1] / 1000];
			} else {
				self.timeArr = [];
			};
			self.initMainData();
			console.log('timeChange', e)
		},

		/**
		 * 初始化
		 */
		init() {
			// this.initMainData();
			this.initUserInfoData();
			this.initVisitorData();
		},

		/**
		 *
		 */
		async initUserInfoData(isNew) {

			const self = this;
			const postData = {};
			postData.token = self.$store.getters.getToken;
			var res = await self.$$api_userInfoGet({
				data: postData
			});
			if (res.info.data.length > 0) {
				self.user = res.info.data[0];
			} else {
				self.user = {};
			};

		},


		/**
		 * 列表主函数
		 */
		async initMainData(isNew) {

			const self = this;
			self.loading = true;
			const postData = {};
			if (isNew) {
				self.mainData = [];
			};
			postData.token = self.$store.getters.getToken;
			postData.behavior = 1;
			postData.transport_status = 0;
			if (self.timeArr.length > 0) {
				postData.create_time = ['between', self.timeArr];
			};
			var res = await self.$$api_searchStatiscOrder({
				data: postData
			});

			if (res.info.data.length > 0) {
				self.mainData = res.info.data;
			}
			self.loading = false;
		},

		/**
		 * 列表主函数
		 */
		async initVisitorData(isNew) {

			const self = this;
			const postData = {};
			if (isNew) {
				self.visitorPaginate.currentPage = 1;
				self.visitorData = [];
			};
			postData.order = {
				'create_time': 'desc'
			};
			postData.searchItem = {
				thirdapp_id: 2,
				'create_time': ['between', [new Date(new Date().toLocaleDateString()).getTime() / 1000 - 6 * 86400, new Date(new Date()
					.toLocaleDateString()).getTime() / 1000 + 86400]]
			};
			var res = await self.$$api_visitorLogsGet({
				data: postData
			});
			self.visitorData = res.info.data;
			var echartsOptions = {
				title: {
					text: '访客曲线'
				},
				tooltip: {
					trigger: 'axis'
				},
				legend: {
					data: ['访客数']
				},
				grid: {
					left: '3%',
					right: '4%',
					bottom: '3%',
					containLabel: true
				},
				xAxis: {
					type: 'category',
					boundaryGap: false,
					axisLabel: { //坐标轴刻度标签的相关设置。
						interval: 0,
						rotate: "60"
					},
					data: []
				},
				yAxis: {
					type: 'value'
				},
				series: [{
					name: '访客数',
					type: 'line',
					stack: '总量',
					data: []
				}],
			};
			for (var i = 0; i < self.visitorData.length; i++) {
				var create_day = self.visitorData[i]['create_time'].substring(0, 10);
				var index = echartsOptions.xAxis.data.indexOf(create_day);
				if (index > -1) {
					echartsOptions.series[0]['data'][index] = echartsOptions.series[0]['data'][index] + 1;
				} else {
					echartsOptions.xAxis.data.push(create_day);
					echartsOptions.series[0]['data'].push(0);
				};
			};
			self.echartsOptions = echartsOptions;
			console.log('echartsOptions', echartsOptions)
		},

	},


}



// WEBPACK FOOTER //
// ./src/views/dashboard/dashboard.js